<script>

import { captureException } from '@/Sentry';
import GeneralError from '@/views/dialogs/GeneralError';

export default {
  name: 'GeneralError',
  methods: {
    logErrorAndShowDialog(error) {
      captureException(error);
      this.$q.dialog({
        component: GeneralError,
        parent: this,
      });
    },
  },
};

</script>
